const computeRerankedCount = searchResults => {
    if (searchResults?.userData?.[0]?.['shopbot-reranked-count'])
        return searchResults.userData[0]['shopbot-reranked-count'];

    if (searchResults?.hits) {
        return searchResults.hits.reduce((currentCount, currentitem) => {
            if (currentitem.reranked) return currentCount + 1;
            return currentCount;
        }, 0);
    }
    return 0;
};

export default computeRerankedCount;
